<template>
  <section class="wrapper" :class="classes">
    <div class="wrapper__content">
      <header v-if="heading || subheading" class="wrapper__header">
        <h2 v-if="heading">{{ heading }}</h2>
        <div v-if="subheading" v-html="subheading"></div>
      </header>
      <slot></slot>
    </div>
  </section>
</template>

<script lang="js">
  export default  {
    name: 'lms-wrapper',
    props: {
      size: {
        type: String,
        default: '',
      },
      bg: {
        type: String,
        default: '',
      },
      topSpacing: {
        type: String,
        default: '',
      },
      heading: {
        type: String,
      },
      subheading: {
        type: String
      }
    },
    computed: {
      classes() {
        let cssClasses = [];

        if (this.size) {
          cssClasses.push(`wrapper--${this.size}`);
        }

        if (this.bg) {
          cssClasses.push(`wrapper--${this.bg}`);
        }

        if (this.topSpacing) {
          cssClasses.push(`wrapper--${this.topSpacing}`)
        }

        return cssClasses;
      },
    },
}
</script>
